"use client";
import { useSeats } from '@/components/providers/SeatsProvider';
import { getDerivedValues } from '@/lib/config';

export function useSeatsData() {
  const { remainingSeats, totalSeats, isLoading, error } = useSeats();
  
  // Use the getDerivedValues function with dynamic data
  const derivedValues = getDerivedValues();
  
  // Override with dynamic values
  const dynamicDerivedValues = {
    ...derivedValues,
    remainingSeats,
    totalSeats,
    percentageFilled: Math.round(((totalSeats - remainingSeats) / totalSeats) * 100),
    showUrgency: remainingSeats <= 25,
    seatColor: remainingSeats <= 2
      ? "#ff4444"
      : remainingSeats <= 25
        ? "#ff8c00"
        : "#97d700",
    remainingSeatsText: `${remainingSeats} plazas restantes`,
    urgencyMessage: remainingSeats <= 2
      ? "¡Últimas plazas disponibles!"
      : remainingSeats <= 25
        ? "¡Pocas plazas disponibles!"
        : "Plazas disponibles"
  };
  
  return {
    ...dynamicDerivedValues,
    isLoading,
    error
  };
}